import { render } from "./OverviewTrivia.vue?vue&type=template&id=ec78281a&scoped=true"
import script from "./OverviewTrivia.vue?vue&type=script&lang=js"
export * from "./OverviewTrivia.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=ec78281a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec78281a"]])

export default __exports__